/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ClassroomdisciplineSharedCoursesQueryResponse,
  GetApiV1ClassroomdisciplineSharedCoursesQueryParams,
  GetApiV1ClassroomdisciplineSharedCourses401,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedCourses.ts";

function getGetApiV1ClassroomdisciplineSharedCoursesUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/classroomdiscipline/shared/courses` as const,
  };
  return res;
}

/**
 * @description  **(Requer Authorization para autenticação)**
 * @summary Lookup de cursos ativos (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/shared/courses}
 */
export async function getApiV1ClassroomdisciplineSharedCourses(
  params?: GetApiV1ClassroomdisciplineSharedCoursesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ClassroomdisciplineSharedCoursesQueryResponse,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedCourses401>,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ClassroomdisciplineSharedCoursesUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
